export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Best Selling',
            sort: [
                {
                    field: 'score',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price, low to high',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price, high to low',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'alphabetical',
        value: {
            name: 'Alphabetical, A-Z',
            sort: [
                {
                    field: 'name',
                    order: 'asc',
                },
            ],
        },
    },
    {
        id: '-alphabetical',
        value: {
            name: 'Alphabetical, Z-A',
            sort: [
                {
                    field: 'name',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: '-date',
        value: {
            name: 'Newest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'date',
        value: {
            name: 'Oldest',
            sort: [
                {
                    field: 'datePublished',
                    order: 'asc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteSize: 6,
    keywordsSize: 8,
    articlesSize: 4,
    historySize: 6,
    currency: 'USD'
}

export const desktopExpandedFacets = ['Tea Type', 'Caffeine', 'Unit', 'Price', 'Packaging Type', 'Preferences']

export const customFacets = [
    {
        // facet name
        name: 'Flavored',
        custom: {
            // old value name: new value name
            Yes: 'Flavored',
            No: 'Unflavored',
        },
        // old value names ordered in array
        order: ['Yes', 'No'],
    },
    {
        name: 'Available',
        custom: {
            true: 'In Stock',
            false: false,
        },
    },
    {
        name: 'Kosher',
        custom: {
            KSA: 'Kosher',
            No: false
        },
    },
    {
        name: 'Organic',
        custom: {
            Yes: 'Organic',
            No: false
        },
    },
]

export const combinedFacetsConfig = [
    {
        name: 'Preferences',
        facetNames: [
            'Flavored',
            'Kosher',
            'Organic',
        ]
    },
];


export const allCombinedFacets = combinedFacetsConfig.reduce((acc, obj) => {
    return acc.concat(obj.facetNames)
}, []);